export default {
  blog_logo: "",
  gravatar_source: "",
  comment_gravatar_default: "mm",
};
